module.exports = __webpack_public_path__ + "static/media/yellow-cluster.0d850410.svg";